<neo-calendario-cabecera [vista]="'day'" [(diaVista)]="diaVista" (vistaCambia)="onVistaCambia($event)" [botonHoy]="true"
    (disVistaCambia)="onDiaVistaCambia($event)"></neo-calendario-cabecera>